import { useReport } from './hooks/use-context';

export function Deviations() {
  const { body } = useReport();
  const { has_risks, justificativa, fotos, providencias } = body;

  const cellStyle = {
    padding: '4px 8px',
    border: '1px solid black',
  };

  const valueStyle = {
    backgroundColor: '#ffffcc',
  };

  const answerValue = (has_risks?.answers?.[0]?.option || has_risks?.answers?.[0]?.content)?.toLowerCase();
  const hasDeviation = answerValue === 'não conforme' || answerValue === 'sim';

  return (
    <div style={{ marginBottom: '8px', fontFamily: 'Arial, sans-serif' }}>
      <div
        style={{
          width: '100%',
          backgroundColor: '#d3d3d3',
          textAlign: 'center',
          padding: '4px',
          fontWeight: 'bold',
          border: '1px solid black',
          borderBottom: 'none',
        }}
      >
        DESVIOS E PROVIDÊNCIAS
      </div>

      <div style={{ ...cellStyle }}>
        <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>
          Existem situações de risco na área?
        </div>
        <div
          style={{
            ...valueStyle,
            padding: '4px',
            textAlign: 'center',
            border: '1px solid #ccc',
          }}
        >
          {has_risks?.answers?.[0]?.option || has_risks?.answers?.[0]?.content || '-'}
        </div>
      </div>

      {hasDeviation && (
        <>
          <div style={{ ...cellStyle, borderTop: 'none' }}>
            <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>
              Justificativa:
            </div>
            <div
              style={{
                ...valueStyle,
                padding: '4px',
                minHeight: '40px',
                border: '1px solid #ccc',
              }}
            >
              {justificativa?.answers?.[0]?.option || justificativa?.answers?.[0]?.content || '-'}
            </div>
          </div>

          <div style={{ ...cellStyle, borderTop: 'none' }}>
            <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>
              Quais foram as providências?
            </div>
            <div
              style={{
                ...valueStyle,
                padding: '4px',
                minHeight: '40px',
                border: '1px solid #ccc',
              }}
            >
              {providencias?.answers?.[0]?.option || providencias?.answers?.[0]?.content || '-'}
            </div>
          </div>

          <div style={{ ...cellStyle, borderTop: 'none' }}>
            <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>
              Fotos:
            </div>
            <div
              style={{
                display: 'flex',
                gap: '8px',
                flexWrap: 'wrap',
                justifyContent: 'center',
              }}
            >
              {fotos?.answers?.length ? (
                fotos.answers.map((answer, index) => {
                  const url = answer.content || '';
                  if (!url) return null;
                  return (
                    /* eslint-disable-next-line @next/next/no-img-element */
                    <img
                      key={`foto-${index}`}
                      src={url}
                      alt={`Foto do desvio ${index + 1}`}
                      style={{
                        maxWidth: '200px',
                        maxHeight: '200px',
                        objectFit: 'contain',
                        border: '1px solid #ccc',
                      }}
                    />
                  );
                })
              ) : (
                <div
                  style={{ padding: '8px', fontStyle: 'italic', color: '#666' }}
                >
                  Nenhuma foto anexada.
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
